import { HttpInterceptorFn } from '@angular/common/http';

export const cleanParamsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.params || req.params.keys().length === 0) {
    return next(req);
  }

  let params = req.params;

  req.params.keys().forEach((key) => {
    const value = req.params.get(key);
    
    if (value == 'null' || value == null || value == undefined || value == 'undefined') {
      console.log(value);
      
      params = params.delete(key);
    }
  });

  return next(req.clone({ params }));
};
